import { atom } from 'jotai';
import { ElementType } from '~/common/typescript/models/Element';

export const elementType_Atom = atom<ElementType>(ElementType.POINT);

export const showElementPanel_Atom = atom<boolean>(false);
